import { render, staticRenderFns } from "./beneficary.vue?vue&type=template&id=29e98cff&scoped=true&"
import script from "./beneficary.vue?vue&type=script&lang=js&"
export * from "./beneficary.vue?vue&type=script&lang=js&"
import style0 from "./beneficary.vue?vue&type=style&index=0&id=29e98cff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e98cff",
  null
  
)

export default component.exports